// Load Styles
// import '../scss/main.scss';

// Load Bootstrap init
import { initBootstrap } from "./bootstrap.js";

// // Loading bootstrap with optional features
initBootstrap({
    tooltip: false,
    popover: false,
    toasts: false,
});

// Your app code
// console.log(`Hello ${process.env.HELLO}`);
const isTouchDevice = 'ontouchstart' in window;


function isSmall() {
    return (window.innerWidth < 640 && window.innerHeight > window.innerWidth);
}
function isMobile() {
    return mobileSniff();// /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(window.navigator.userAgent);
}
function iPhoneSniff() {
    return /iP(ad|hone|od).*OS/.test(window.navigator.userAgent);
}
function androidSniff() {
    return /Android/.test(window.navigator.userAgent);
}
function mobileSniff() {
    return iPhoneSniff() || androidSniff();
}

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger.js';
import SplitText from 'gsap/SplitText.js';
import ScrollSmoother from "gsap/ScrollSmoother.js";
import MorphSVGPlugin from "gsap/MorphSVGPlugin.js";
gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother, MorphSVGPlugin);
import { DotLottie } from '@lottiefiles/dotlottie-web';

function initCS() {
    // set animations
    let title1 = document.querySelector(".title .t1"),
        title2 = document.querySelector(".title .t2");
    let split1 = new SplitText(title1, { type: "chars" }),
        split2 = new SplitText(title2, { type: "chars" });
    let titleImg = document.querySelector(".title img");
    let tlc1 = gsap.timeline();

    tlc1.to(document.body, { autoAlpha: 1, duration: 0.5, delay: 1 });

    tlc1.from(split1.chars, {
        autoAlpha: 0,
        y: "+=15",
        stagger: 0.05,
        delay: 0.5,
        duration: 0.5,
    })
        .from(titleImg, {
            autoAlpha: 0,
            duration: 0.3,
        })
        .from(split2.chars, {
            autoAlpha: 0,
            y: "+=15",
            stagger: 0.05,
            duration: 0.5,
        });

    let bottomEl = document.querySelector(".bottom-el");
    let bottomElwrapper = document.querySelector(".bottm-el-wrapper");
    let topEl = document.querySelector(".top-el");
    let video = document.querySelector(".video");
    tlc1.add(gsap.from(bottomEl, { scale: 0, duration: 1.9, ease: "power4.out" }), "<")
        .add(gsap.from(topEl, { scale: 0, duration: 1.9, ease: "power4.out" }), "<+=0.3")
        .add(gsap.from(video, { scale: 0, duration: 1.9, ease: "power4.out" }), "<+=0.3");

    let texts = document.querySelectorAll(".text-content .texts .text");
    let _h = 0;
    let textPause = 5;//seconds
    texts.forEach(t => { t.offsetHeight > _h ? _h = t.offsetHeight : _h = _h });
    document.querySelector(".text-content .texts").style.height = _h + "px";
    let tl2 = gsap.timeline({ repeat: -1 });
    let txt1 = new SplitText(document.querySelector(".text-content .text1"), { type: "words,lines" });
    let txt2 = new SplitText(document.querySelector(".text-content .text2"), { type: "words,lines" });
    let txt3 = new SplitText(document.querySelector(".text-content .text3"), { type: "words,lines" });
    let ani1From = gsap.from(txt1.lines, { duration: 0.6, autoAlpha: 0, stagger: 0.2 });
    let ani1To = gsap.to(txt1.lines, { duration: 0.3, autoAlpha: 0, stagger: 0.1 });
    let ani2From = gsap.from(txt2.lines, { duration: 0.6, autoAlpha: 0, stagger: 0.2 });
    let ani2To = gsap.to(txt2.lines, { duration: 0.3, autoAlpha: 0, stagger: 0.1 });
    let ani3From = gsap.from(txt3.lines, { duration: 0.6, autoAlpha: 0, stagger: 0.2 });
    let ani3To = gsap.to(txt3.lines, { duration: 0.3, autoAlpha: 0, stagger: 0.1 });
    let pause = gsap.to({ t: 0 }, { duration: textPause, t: 1 });
    tl2.add(ani1From)
        .add(gsap.to(document.querySelector(".text-content .text1 span"), { duration: textPause, width: "100%", ease: "none" }), ">")
        .add(pause, "<")
        .add(ani1To)
        .add(ani2From)
        .add(gsap.to(document.querySelector(".text-content .text2 span"), { duration: textPause, width: "100%", ease: "none" }), ">")
        .add(pause, "<")
        .add(ani2To)
        .add(ani3From)
        .add(gsap.to(document.querySelector(".text-content .text3 span"), { duration: textPause, width: "100%", ease: "none" }), ">")
        .add(pause, "<")
        .add(ani3To)

    tlc1.add(
        gsap.from(document.querySelector(".text-content .btn"), { duration: 0.3, autoAlpha: 0 }), ">0.8"
    )
    tlc1.add(tl2, ">-0.8");
    let mm = gsap.matchMedia();
    mm.add("(min-width: 800px)", () => {
        tlc1.add(gsap.timeline({ repeat: -1 }).to(bottomElwrapper, { duration: 2, scale: (1 + 0.05 * Math.random()) }).to(bottomElwrapper, { duration: 2, scale: 1 }));
    })

    // document.querySelector(".text-content .texts")
    //     .addEventListener('mouseover', () => tlc1.pause());
    // document.querySelector(".text-content .texts")
    //     .addEventListener('mouseleave', () => tlc1.resume());

}

function commonInit() {
    const header = document.querySelector("header");
    let lastScrollTop = header.style.top;
    window.addEventListener("scroll", scrollHide);

    function scrollHide() {
        var st = window.scrollY || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            header.classList.add('hide');
        } else {
            header.classList.remove('hide');
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }
    ScrollTrigger.create({
        trigger: document.body,
        start: "top top-=100",
        // end: "bottom bottom-=100",
        toggleClass: { targets: "header", className: "scrolled" }
    });
    ScrollSmoother.create({
        smooth: 1,
        effects: true,
    });
}

function initHome() {
    commonInit();
    homePageAnimations();
}

function initProjects() {
    commonInit();
    const filterBtn = document.querySelector(".dropdown-toggle");
    const wrapper = document.querySelector(".themes-filter-wrapper");
    const close = document.querySelector(".close-filter");
    gsap.set(wrapper, {autoAlpha: 0});
    filterBtn.addEventListener("click", event => {
        event.preventDefault();
        document.querySelector('.ProjectsPage').classList.add("overflow-hidden")
        const btns = wrapper.querySelectorAll("li a");
        gsap.set(btns, {autoAlpha: 1, y: "+=60"});
        gsap.to(wrapper, {duration: 0.3, autoAlpha: 1, onComplete: () => {
            gsap.to(btns, {
                duration: 0.8,
                y: 0,
                autoAlpha: 1,
                stagger: 0.05,
            })
        }});
        return false;
    });
    close.addEventListener("click", event => {
        if (event.target.tagName != "A") {
            event.preventDefault();
            document.querySelector('.ProjectsPage').classList.remove("overflow-hidden")
            gsap.to(wrapper, {duration: 0.3, autoAlpha: 0});
        }
        return false;
    });

    if (isTouchDevice) {

    } else {

        const closeFilterBtn = document.querySelector(".close-filter-btn");
        let xTo = gsap.quickTo(closeFilterBtn, "left", { duration: 0.3, ease: "power3" }),
            yTo = gsap.quickTo(closeFilterBtn, "top", { duration: 0.3, ease: "power3" }),
            alphaTo = gsap.quickSetter(closeFilterBtn, "opacity");
        const followClose = (event) => {
            // console.log(event.target.tagName)
            const target = event.target;
            if (target.tagName == "A") {
                alphaTo(0);
            } else {
                alphaTo(1);
            }
            const bounding = event.currentTarget.getBoundingClientRect();
            xTo(event.clientX - bounding.left - closeFilterBtn.offsetWidth/2 - 10);
            yTo(event.clientY - bounding.top - closeFilterBtn.offsetHeight/2 - 10);
        }
        const startFollowClose = (event) => {
            // gsap.to(closeFilterBtn, {duration: 0, autoAlpha: 1, onComplete: () => {document.body.style.cursor = "none";}})
            document.body.style.cursor = "none";
            alphaTo(1)
            close.addEventListener("mousemove", followClose);
            close.addEventListener("mousewheel", followClose);
        }
        const unFollowClose = (event) => {
            // gsap.to(closeFilterBtn, {duration: 0, autoAlpha: 0, onComplete: () => {document.body.style.cursor = "default";}})
            document.body.style.cursor = "default";
            alphaTo(0)
            close.removeEventListener("mousemove", followClose);
            close.removeEventListener("mousewheel", followClose);
        }
        close.addEventListener("mouseover", startFollowClose);
        close.addEventListener("mouseout", unFollowClose);

    }

    projectsPageAnimations();
}

function initSingleProject() {
    commonInit();
    singleProjectAnimations();
}

function initAboutUs() {
    commonInit();
    aboutUsAnimations();
}

function initTalents() {
    commonInit();
    talentsAnimations();
}

function initSingleArtist() {
    commonInit();
    singleArtistAnimations();
}

function initBlog() {
    commonInit();
    const className = document.body.classList.contains("Blog") ? ".Blog" : (document.body.classList.contains("InsightsPage") ? ".InsightsPage" : ".PodcastsPage");
    const filterBtn = document.querySelector(".dropdown-toggle");
    const wrapper = document.querySelector(".themes-filter-wrapper");
    const close = document.querySelector(".close-filter");
    gsap.set(wrapper, {autoAlpha: 0});
    if (filterBtn) filterBtn.addEventListener("click", event => {
        event.preventDefault();
        document.querySelector(className).classList.add("overflow-hidden")
        const btns = wrapper.querySelectorAll("li a");
        gsap.set(btns, {autoAlpha: 1, y: "+=60"});
        gsap.to(wrapper, {duration: 0.3, autoAlpha: 1, onComplete: () => {
            gsap.to(btns, {
                duration: 0.8,
                y: 0,
                autoAlpha: 1,
                stagger: 0.05,
            })
        }});
        return false;
    });
    if (close) close.addEventListener("click", event => {
        if (event.target.tagName != "A") {
            event.preventDefault();
            document.querySelector(className).classList.remove("overflow-hidden")
            gsap.to(wrapper, {duration: 0.3, autoAlpha: 0});
        }
        return false;
    });

    if (isTouchDevice) {

    } else {
        if (close) {
            const closeFilterBtn = document.querySelector(".close-filter-btn");
            let xTo = gsap.quickTo(closeFilterBtn, "left", { duration: 0.3, ease: "power3" }),
                yTo = gsap.quickTo(closeFilterBtn, "top", { duration: 0.3, ease: "power3" }),
                alphaTo = gsap.quickSetter(closeFilterBtn, "opacity");
            const followClose = (event) => {
                // console.log(event.target.tagName)
                const target = event.target;
                if (target.tagName == "A") {
                    alphaTo(0);
                } else {
                    alphaTo(1);
                }
                const bounding = event.currentTarget.getBoundingClientRect();
                xTo(event.clientX - bounding.left - closeFilterBtn.offsetWidth/2 - 10);
                yTo(event.clientY - bounding.top - closeFilterBtn.offsetHeight/2 - 10);
            }
            const startFollowClose = (event) => {
                // gsap.to(closeFilterBtn, {duration: 0, autoAlpha: 1, onComplete: () => {document.body.style.cursor = "none";}})
                document.body.style.cursor = "none";
                alphaTo(1)
                close.addEventListener("mousemove", followClose);
                close.addEventListener("mousewheel", followClose);
            }
            const unFollowClose = (event) => {
                // gsap.to(closeFilterBtn, {duration: 0, autoAlpha: 0, onComplete: () => {document.body.style.cursor = "default";}})
                document.body.style.cursor = "default";
                alphaTo(0)
                close.removeEventListener("mousemove", followClose);
                close.removeEventListener("mousewheel", followClose);
            }
            close.addEventListener("mouseover", startFollowClose);
            close.addEventListener("mouseout", unFollowClose);
        }
    }
    blogAnimations();
}

function initBlogArticle() {
    commonInit();
    blogArticleAnimations();
}

function initErrorPage() {
    commonInit();
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));
}

const showPageDelay = 0.5; // seconds
function homePageAnimations() {
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));

    // SET HERO START ANIMATION
    let hero = new SplitText(".HomeHero .h1", {type: "chars,words", wordsClass: "hword"});
    tl1.from(hero.chars, {
        duration: 0.7,
        y: "-=15",
        // rotateY: 90,
        // rotateZ: 35,
        scale: 2,
        autoAlpha: 0,
        stagger: 0.05,
    })
    tl1.from(".bottom-el-wrapper", {
            duration: 1.5,
            scale: 0,
            autoAlpha: 0,
            ease: "power3",
        })
        .from(".top-el-wrapper", {
            duration: 1.5,
            scale: 0,
            autoAlpha: 0,
            ease: "power3",
        }, "<0.2")
        .from(".video-wrapper", {
            duration: 0.9,
            // scale: 0,
            // rotation: 15,
            autoAlpha: 0,
            ease: "power3",
        }, "<0.6")
    
    // SET BACKGROUND COLOR CHANGE
    let bg = document.querySelector(".backgrounds");
    ScrollTrigger.create({
        trigger: '.HomeAbout',
        // markers:true,
        start: ScrollTrigger.isTouch === 1 ? "top center+=5%" : "top center+=25%",
        // end:"bottom 0%",
        onEnter: () => {
            gsap.to(bg, { duration: 0.6, backgroundColor: '#fffdfa' })
        },
        onLeaveBack: () => {
            gsap.to(bg, { duration: 0.6, backgroundColor: '#1706f4' })
        },
    });
    
    // SET VIDEO PLAY BUTTON FOLLOWER
    const videoContainer = document.querySelector(".video-container");
    const playVideoBtn = document.querySelector(".play-video");
    const videoModal = document.querySelector("#videoModal");
    const preview = document.getElementById("VideoPreview");
    if (isTouchDevice) {
        const bounding = videoContainer.getBoundingClientRect();
        playVideoBtn.style.left = (bounding.left - playVideoBtn.offsetWidth/2 - 10) + "px";
        playVideoBtn.style.top = (bounding.top - playVideoBtn.offsetHeight/2 - 10) + "px";
    } else {
        let xTo = gsap.quickTo(playVideoBtn, "x", { duration: 0.4, ease: "power3" }),
            yTo = gsap.quickTo(playVideoBtn, "y", { duration: 0.4, ease: "power3" });
        videoModal.addEventListener('hidden.bs.modal', event => {
            preview.play();
        })
        videoModal.addEventListener('hide.bs.modal', event => {
            const theModal = playVideoBtn.getAttribute("data-bs-target");
            document.querySelector(theModal+' iframe').setAttribute('src', "");
        })
        const openVideoPlayer = (event) => {
            console.log("play video")
            let theModal = playVideoBtn.getAttribute("data-bs-target"),
                videoSRC = playVideoBtn.getAttribute("data-videourl"),
                videoSRCauto = videoSRC+"?autoplay=1";
            // console.log(theModal, videoSRC, videoSRCauto);
            preview.pause();
            
            document.querySelector(theModal+' iframe').setAttribute('src', videoSRCauto);
            // document.querySelector(theModal+' button.close').click(function () {
            //     document.querySelector(theModal+' iframe').setAttribute('src', videoSRC);
            //     const preview = document.getElementById("VideoPreview");
            //     
            // });
        }
        const followMouse = (event) => {
            const bounding = event.currentTarget.getBoundingClientRect();
            // playVideoBtn.style.left = (event.clientX - bounding.left - playVideoBtn.offsetWidth/2 - 10) + "px";
            // playVideoBtn.style.top = (event.clientY - bounding.top - playVideoBtn.offsetHeight/2 - 10) + "px";
            // gsap.set(playVideoBtn, {
            //     x: event.clientX - bounding.left - playVideoBtn.offsetWidth/2 - 10,
            //     y: event.clientY - bounding.top - playVideoBtn.offsetHeight/2 - 10
            // });
            xTo(event.clientX - bounding.left - playVideoBtn.offsetWidth/2 - 10);
            yTo(event.clientY - bounding.top - playVideoBtn.offsetHeight/2 - 10);
        }
        const startFollowMouse = (event) => {
            gsap.to(playVideoBtn, {duration: 0.3, autoAlpha: 1, onComplete: () => {document.body.style.cursor = "none";}})
            document.body.style.cursor = "none";
            videoContainer.addEventListener("mousemove", followMouse);
            videoContainer.addEventListener("mousewheel", followMouse);
            videoContainer.addEventListener("click", openVideoPlayer);
        }
        const unFollowMouse = (event) => {
            gsap.to(playVideoBtn, {duration: 0.3, autoAlpha: 0, onComplete: () => {document.body.style.cursor = "default";}})
            document.body.style.cursor = "default";
            videoContainer.removeEventListener("mousemove", followMouse);
            videoContainer.removeEventListener("mousewheel", followMouse);
            videoContainer.removeEventListener("click", openVideoPlayer);
        }
        videoContainer.addEventListener("mouseover", startFollowMouse);
        videoContainer.addEventListener("mouseout", unFollowMouse);
        gsap.to(videoContainer, {
            duration: 0.6,
            scale: 1.15,
            scrollTrigger: {
                trigger: ".HomeHero",
                start: "top -=100",
                end: "bottom 0%",
                scrub: 1,
            }
        });
    }

    // ABOUT SECTION ANIMATION
    let split1 = new SplitText(document.querySelector(".HomeAbout .t1"), { type: "chars" }),
        split2 = new SplitText(document.querySelector(".HomeAbout .ext-t2"), { type: "chars" }),
        split3 = new SplitText(document.querySelector(".HomeAbout .subtitle"), { type: "words,lines", linesClass: "lineParent" });
    let atl = gsap.timeline({
        paused: true,
        scrollTrigger: {
            trigger: ".HomeAbout",
            start: "top center+=5%",
            // toggleActions: "play pause resume reset",
            onEnter: () => {
                atl.play()
            },
            onLeaveBack: () => {
                atl.reverse()
            },
        }
    });
    atl.from(split1.chars, {
        duration: 0.6,
        y: "+=15",
        autoAlpha: 0,
        stagger: 0.02,
    })
        .from(".HomeAbout .alt-t2", {
            duration: 0.3,
            autoAlpha: 0,
            left: "-=15",
        }, ">-0.3")
        .from(split2.chars, {
            duration: 0.6,
            y: "+=15",
            autoAlpha: 0,
            stagger: 0.02,
        })
        .from(split3.words, {
            duration: 0.8,
            y: 65,
            rotation: 10,
            stagger: 0.02,
            ease: "back"
        })
    
    // SET SECTION TITLES ANIMATION
    const titles = document.querySelectorAll(".a-title");
    titles.forEach(title => {
        const splitTxt = new SplitText(title, {type: "chars,words"});
        gsap.from(splitTxt.chars, {
            duration: 0.4,
            // scale: 2,
            x: "-=20",
            autoAlpha: 0,
            rotateY: 50,
            // rotateZ: -15,
            stagger: 0.05,
            scrollTrigger: {
                trigger: title,
                start: "top center+=20%",
                toggleActions: "play none none reverse",
            }
        });
    });
    
    // SET PROJECTS ANIMATION
    const projects = document.querySelectorAll(".sp-col");
    projects.forEach(project => {
        gsap.from(project, {
            duration: 1.2,
            y: "+=50",
            autoAlpha: 0,
            ease: "circ",
            scrollTrigger: {
                trigger: project,
                start: "top center+=20%",
                toggleActions: "play none none reverse",
            }
        })
    });

    if (isSmall()) {
        
    // SET SERVICES + LOTTIE INIT
        const services = document.querySelectorAll(".single-service__card");
        services.forEach((service, idx) => {

            const canv = service.querySelector("canvas");
            const dotLottie = new DotLottie({
                // autoplay: true,
                loop: true,
                canvas: canv,
                mode: "bounce",
                direction: "-1",
                src: canv.dataset["src"],
            });
            gsap.from(service, {
                duration: 0.8,
                y: "+=35",
                autoAlpha: 0,
                ease: "power3.out",
                stagger: 0.1,
                scrollTrigger: {
                    trigger: service,
                    start: "top center-=15%",
                    // toggleActions: "play pause resume reverse",
                },
                onComplete: () => {
                    dotLottie.play();
                }
            })
        });
    } else {
        const services = document.querySelectorAll(".single-service__card");
        services.forEach((service, idx) => {

            const canv = service.querySelector("canvas");
            const dotLottie = new DotLottie({
                // autoplay: true,
                loop: true,
                canvas: canv,
                mode: "bounce",
                direction: "-1",
                src: canv.dataset["src"],
            });
            service.addEventListener("mouseenter", event => {
                dotLottie.play();
            })
            service.addEventListener("mouseleave", event => {
                dotLottie.stop();
            })

        });
        gsap.from(services, {
            duration: 0.8,
            y: "+=35",
            autoAlpha: 0,
            ease: "power3.out",
            stagger: 0.1,
            scrollTrigger: {
                trigger: ".HomeServices",
                start: "top center-=15%",
                toggleActions: "play pause resume reverse",
            }
        })
    }
    
    // SET POSTS ANIMATION
    const posts = document.querySelectorAll(".single-post");
    gsap.from(posts, {
        duration: 1.2,
        y: "+=50",
        autoAlpha: 0,
        ease: "circ",
        stagger: 0.2,
        scrollTrigger: {
            trigger: ".HomeBlog",
            start: "top center+=20%",
            toggleActions: "play pause resume reverse",
        }
    })
}

function projectsPageAnimations() {
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));
}

function singleProjectAnimations() {
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));
}

function talentsAnimations() {
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));

    // Brands logo wall – random logo swapping over time
    const BRAND_FADE_DURATION = 0.8; // seconds – fade out / in
    const BRAND_SWAP_MIN_DELAY = 1.6; // seconds – min time logo stays visible
    const BRAND_SWAP_MAX_DELAY = 3.2; // seconds – max time logo stays visible

    const brandsSection = document.querySelector(".Brands");
    const brandsLists = document.querySelectorAll(".brands-list .brands-list__list");
    const extraLogos = window.extraLogos || [];
    // const extraLogos = [
    //     "/assets/images/tmp/11.jpg",
    //     "/assets/images/tmp/12.jpg",
    //     "/assets/images/tmp/14.jpg",
    //     "/assets/images/tmp/15.jpg",
    //     "/assets/images/tmp/16.jpg",
    //     "/assets/images/tmp/17.jpg",
    // ];
    const brandsListsArr = [...brandsLists];

    if (extraLogos.length > 0) {
        // Make sure hidden template list becomes visible; CSS handles blur/opacity.
        // brandsListsArr.forEach((list) => {
        //     if (list.style.display === "none") {
        //         list.style.removeProperty("display");
        //     }
        // });

        // ScrollTrigger.create({
        //     trigger: brandsSection,
        //     start: "top 80%",
        //     once: true,
        //     onEnter: () => {
                const allImgEls = Array.from(
                    document.querySelectorAll(".brands-list .brands-list__item img")
                );

                const normalizeSrc = (src) => {
                    if (!src) return "";
                    // Keep absolute URLs intact, but normalize local paths against webRoot.
                    if (/^https?:\/\//i.test(src) || /^data:/i.test(src)) return src;
                    return `${window.webRoot || ""}${src}`.replace(/\/{2,}/g, "/");
                };

                const preloadImage = (src) =>
                    new Promise((resolve) => {
                        const url = normalizeSrc(src);
                        if (!url) return resolve({ ok: false, src: url });
                        const tmp = new Image();
                        tmp.decoding = "async";
                        tmp.onload = async () => {
                            // Ensure the bitmap is decoded, not just downloaded.
                            try {
                                if (typeof tmp.decode === "function") await tmp.decode();
                            } catch (_) {}
                            resolve({ ok: true, src: url });
                        };
                        tmp.onerror = () => resolve({ ok: false, src: url });
                        tmp.src = url;
                        // If cached, onload may fire sync-ish in some browsers; this is fine.
                    });

                const preloadImages = async (srcs) => {
                    const unique = Array.from(new Set((srcs || []).map(normalizeSrc).filter(Boolean)));
                    await Promise.allSettled(unique.map(preloadImage));
                    return unique;
                };

                // Build pool of logo sources from DOM plus extra assets if available.
                const domSrcPool = Array.from(
                    new Set(
                        allImgEls
                            .map((img) => img.getAttribute("src"))
                            .filter(Boolean)
                    )
                );

                const logoPool = Array.from(
                    new Set([
                        ...domSrcPool,
                        ...extraLogos.map((p) =>
                            normalizeSrc(p)
                        ),
                    ])
                );

                if (!allImgEls.length || logoPool.length < 2) return;

                // Ensure all visible logos are unique at any moment:
                // split logoPool into active (visible) and inactive (off-screen) sets.
                let activeLogos;
                let inactiveLogos;

                if (logoPool.length >= allImgEls.length) {
                    const shuffled = gsap.utils.shuffle([...logoPool]);
                    activeLogos = shuffled.slice(0, allImgEls.length);
                    inactiveLogos = shuffled.slice(allImgEls.length);
                } else {
                    // Fallback: not enough unique logos; use whatever we have but still keep them unique.
                    activeLogos = [...logoPool];
                    inactiveLogos = [];
                }

                const applySrcAfterLoad = async (img, src) => {
                    const url = normalizeSrc(src);
                    if (!url) return false;
                    await preloadImage(url);
                    img.setAttribute("src", url);
                    // Avoid brief old-frame display while the element decodes the new bitmap.
                    try {
                        if (typeof img.decode === "function") await img.decode();
                    } catch (_) {}
                    return true;
                };

                // Preload everything once up-front, then set initial images (prevents "pop in" on first reveal).
                preloadImages(logoPool).then(() => {
                    allImgEls.forEach((img, idx) => {
                        const src = activeLogos[idx % activeLogos.length];
                        img.setAttribute("src", normalizeSrc(src));
                    });
                });

                const swapWithInactive = () => {
                    if (!inactiveLogos.length) return false;

                    const imgIndex = gsap.utils.random(0, allImgEls.length - 1, 1);
                    const inactiveIndex = gsap.utils.random(0, inactiveLogos.length - 1, 1);

                    const img = allImgEls[imgIndex];
                    const newSrc = inactiveLogos[inactiveIndex];
                    const oldSrc = activeLogos[imgIndex];

                    if (!newSrc || !oldSrc || newSrc === oldSrc) return false;

                    // Swap between active and inactive pools to keep global uniqueness.
                    activeLogos[imgIndex] = newSrc;
                    inactiveLogos[inactiveIndex] = oldSrc;

                    gsap.to(img, {
                        opacity: 0,
                        duration: BRAND_FADE_DURATION,
                        ease: "power2.inOut",
                        onComplete: async () => {
                            await applySrcAfterLoad(img, newSrc);
                            gsap.to(img, {
                                opacity: 1,
                                duration: BRAND_FADE_DURATION,
                                ease: "power2.inOut",
                            });
                        },
                    });

                    return true;
                };

                const swapWithinActive = () => {
                    if (activeLogos.length < 2) return;

                    let i = gsap.utils.random(0, allImgEls.length - 1, 1);
                    let j = gsap.utils.random(0, allImgEls.length - 1, 1);
                    if (i === j) j = (j + 1) % allImgEls.length;

                    const imgA = allImgEls[i];
                    const imgB = allImgEls[j];
                    const srcA = activeLogos[i];
                    const srcB = activeLogos[j];

                    if (!srcA || !srcB || srcA === srcB) return;

                    activeLogos[i] = srcB;
                    activeLogos[j] = srcA;

                    gsap.to([imgA, imgB], {
                        opacity: 0,
                        duration: BRAND_FADE_DURATION,
                        ease: "power2.inOut",
                        onComplete: async () => {
                            await Promise.all([
                                applySrcAfterLoad(imgA, activeLogos[i]),
                                applySrcAfterLoad(imgB, activeLogos[j]),
                            ]);
                            gsap.to([imgA, imgB], {
                                opacity: 1,
                                duration: BRAND_FADE_DURATION,
                                ease: "power2.inOut",
                            });
                        },
                    });
                };

                const swapStep = () => {
                    // Prefer bringing in new logos from inactive pool; otherwise just permute active ones.
                    const usedInactive = swapWithInactive();
                    if (!usedInactive) {
                        swapWithinActive();
                    }

                    const delay = gsap.utils.random(BRAND_SWAP_MIN_DELAY, BRAND_SWAP_MAX_DELAY);
                    gsap.delayedCall(delay, swapStep);
                };

                swapStep();
        //     }
        // });
    }

    // Text carousel – cycle with GSAP, SplitText char-by-char (hero-style), pagination click, drag to change
    const wrapper = document.querySelector(".TextCarousel .text-carousel-wrapper");
    const carousel = document.querySelector(".TextCarousel .text-carousel");
    if (carousel && wrapper) {
        const items = gsap.utils.toArray(".TextCarousel .text-carousel .text-item");
        const paginationDots = gsap.utils.toArray(".TextCarousel .text-carousel-wrapper .pagination-item");
        const durationOut = 0.3;
        const charDuration = 0.8;
        const charStagger = 0.02;
        const pause = 3;
        const dragThreshold = 50;
        let carouselHeight = 0;

        const splits = items.map((item) => {
            const p = item.querySelector("p");
            carouselHeight = Math.max(carouselHeight, item.offsetHeight);
            return p ? new SplitText(p, { type: "chars, words" }) : null;
        });
        const allChars = splits.filter(Boolean).flatMap((s) => s.words);
        carousel.style.height = carouselHeight + "px";

        let currentIndex = 0;
        let autoTimeout = null;
        let isAnimating = false;

        function goToSlide(index) {
            if (index < 0 || index >= items.length || index === currentIndex) return;
            gsap.killTweensOf(items);
            gsap.killTweensOf(allChars);
            isAnimating = true;
            const fromIndex = currentIndex;
            const currentItem = items[fromIndex];
            const nextItem = items[index];
            currentIndex = index;

            currentItem.classList.remove("current");
            nextItem.classList.add("current");
            paginationDots.forEach((dot, i) => dot.classList.toggle("current", i === currentIndex));

            gsap.to(currentItem, { duration: durationOut, opacity: 0, ease: "power2.inOut" });
            gsap.set(nextItem, { opacity: 1 });
            const nextSplit = splits[index];
            if (nextSplit && nextSplit.words.length) {
                gsap.from(nextSplit.words, {
                    duration: charDuration,
                    y: 65,
                    rotation: 10,
                    ease: "back",
                    stagger: charStagger,
                    autoAlpha: 0,
                    overwrite: true,
                    onComplete: () => {
                        isAnimating = false;
                        scheduleAuto();
                    }
                });
            } else {
                gsap.to(nextItem, { duration: charDuration, opacity: 1, onComplete: () => {
                    isAnimating = false;
                    scheduleAuto();
                }});
            }
        }

        function scheduleAuto() {
            clearTimeout(autoTimeout);
            autoTimeout = setTimeout(() => goToSlide((currentIndex + 1) % items.length), pause * 1000);
        }

        gsap.set(items, { opacity: 0 });
        gsap.set(items[0], { opacity: 1 });
        items.forEach((el, i) => el.classList.toggle("current", i === 0));
        paginationDots.forEach((el, i) => el.classList.toggle("current", i === 0));
        const firstSplit = splits[0];
        if (firstSplit && firstSplit.words.length) {
            gsap.from(firstSplit.words, {
                duration: charDuration,
                y: 65,
                rotation: 10,
                ease: "back",
                autoAlpha: 0,
                stagger: charStagger,
                onComplete: scheduleAuto
            });
        } else {
            scheduleAuto();
        }

        // Pagination click
        paginationDots.forEach((dot, index) => {
            dot.addEventListener("click", (e) => {
                e.preventDefault();
                clearTimeout(autoTimeout);
                goToSlide(index);
            });
        });

        // Drag left/right on text area
        let dragStartX = 0;
        let isDragging = false;

        function onPointerDown(e) {
            if (e.button !== 0 && e.pointerType === "mouse") return;
            if (e.target.closest(".TextCarousel .pagination")) return;
            dragStartX = e.clientX;
            isDragging = true;
            clearTimeout(autoTimeout);
            wrapper.classList.add("is-dragging");
            e.preventDefault();
            wrapper.setPointerCapture?.(e.pointerId);
        }
        function onPointerMove(e) {
            if (!isDragging) return;
            const deltaX = e.clientX - dragStartX;
            if (Math.abs(deltaX) > dragThreshold) {
                if (deltaX < 0) goToSlide((currentIndex + 1) % items.length);
                else goToSlide((currentIndex - 1 + items.length) % items.length);
                dragStartX = e.clientX;
                isDragging = false;
                wrapper.classList.remove("is-dragging");
                wrapper.releasePointerCapture?.(e.pointerId);
            }
        }
        function onPointerUp(e) {
            if (!isDragging) return;
            const deltaX = e.clientX - dragStartX;
            if (Math.abs(deltaX) > dragThreshold) {
                if (deltaX < 0) goToSlide((currentIndex + 1) % items.length);
                else goToSlide((currentIndex - 1 + items.length) % items.length);
            }
            isDragging = false;
            wrapper.classList.remove("is-dragging");
            wrapper.releasePointerCapture?.(e.pointerId);
        }
        wrapper.addEventListener("pointerdown", onPointerDown);
        wrapper.addEventListener("pointermove", onPointerMove);
        wrapper.addEventListener("pointerup", onPointerUp);
        wrapper.addEventListener("pointercancel", onPointerUp);
    }
}

function singleArtistAnimations() {
    // Loading screen animations
    const loadingScreen = document.getElementById("loadingScreen");
    const loadingScreenInnerImg = document.querySelector(".loading-screen__inner img");
    const loadingScreenInnerTitle = document.querySelector(".loading-screen__inner .h1");
    const split3 = new SplitText(loadingScreenInnerTitle, { type: "words,lines" });
    const bottomEl = document.querySelector(".bottom-el");
    const topEl = document.querySelector(".top-el");
    const smallTopEl = document.querySelector(".small-el");
    const minLoadTime = 1.2;
    let tl1 = gsap.timeline();

    if(isMobile()) {
        tl1.set(loadingScreen, { visibility: "visible" });
        tl1.from(loadingScreenInnerImg, {
            // autoAlpha: 0,
            scale: 0.3,
            duration: 0.6,
            ease: "power1.out"
        })
        tl1.from(split3.words, {
            autoAlpha: 0,
            duration: 1.1,
            y: 35,
            rotation: 8,
            stagger: 0.2,
            ease: "back"
        })
        tl1.from(topEl, {
            autoAlpha: 0,
            opacity: 0,
            scale: 0.2,
            duration: 0.6,
            ease: "power1.out"
        }, "<0.6")
        tl1.from(bottomEl, {
            autoAlpha: 0,
            opacity: 0,
            scale: 0.2,
            duration: 0.6,
            ease: "power1.out"
        }, "<0.6")
        tl1.to(document.body.querySelector(".navbar-talents"), { visibility: "visible" });
        tl1.to(document.body.querySelector("main"), { visibility: "visible" });
        tl1.to(loadingScreen, {
            autoAlpha: 0,
            duration: 0.6,
            // delay: minLoadTime,
            pointerEvents: "none",
            onComplete: () => loadingScreen.remove()
        });

    } else {
        tl1.set(loadingScreen, { visibility: "visible" });
        tl1.from(loadingScreenInnerImg, {
            // autoAlpha: 0,
            scale: 0.3,
            duration: 0.6,
            ease: "power1.out"
        })
        tl1.from(split3.words, {
            autoAlpha: 0,
            duration: 1.1,
            y: 35,
            rotation: 8,
            stagger: 0.2,
            ease: "back"
        })
        tl1.from(smallTopEl, {
            autoAlpha: 0,
            opacity: 0,
            scale: 0.2,
            duration: 0.7,
            ease: "power1.out"
        }, ">-0.6")
        tl1.from(topEl, {
            autoAlpha: 0,
            opacity: 0,
            scale: 0.2,
            duration: 1.1,
            ease: "power1.out"
        }, "<0.6")
        tl1.from(bottomEl, {
            autoAlpha: 0,
            opacity: 0,
            scale: 0.2,
            duration: 1.1,
            ease: "power1.out"
        }, "<0.6")
        tl1.to(document.body.querySelector(".navbar-talents"), { visibility: "visible" });
        tl1.to(document.body.querySelector("main"), { visibility: "visible" });
        tl1.to(loadingScreen, {
            autoAlpha: 0,
            duration: 0.6,
            // delay: minLoadTime,
            pointerEvents: "none",
            onComplete: () => loadingScreen.remove()
        });


    }


    // page animations

    // ----------------------------------------------------------------
    // UTILITY: Default ScrollTrigger config
    // ----------------------------------------------------------------
    const ST_DEFAULTS = {
        start: 'top 88%',
        toggleActions: 'play none none none',
    };

    // ----------------------------------------------------------------
    // 1. HERO — fade + slight scale up on load
    // ----------------------------------------------------------------
    // gsap.from('.artist-hero__media', {
    //     opacity: 0,
    //     y: 30,
    //     scale: 0.98,
    //     duration: 1,
    //     ease: 'power3.out',
    //     delay: 0.1,
    // });

    // gsap.from('.artist-hero__play-btn', {
    //     opacity: 0,
    //     scale: 0.8,
    //     duration: 0.6,
    //     ease: 'back.out(1.7)',
    //     delay: 0.6,
    // });

    // ----------------------------------------------------------------
    // 2. ARTIST BIO — stagger fade-up
    // ----------------------------------------------------------------
    gsap.fromTo(['.artist-bio__social', '.artist-bio__name', '.artist-bio__text', '.artist-bio .btn-primary'], {
        opacity: 0,
        top: 40,
    }, {
        scrollTrigger: { trigger: '.artist-bio', ...ST_DEFAULTS },
        opacity: 1,
        top: 0,
        duration: 0.7,
        stagger: 0.12,
        ease: 'power2.out',
    });

    // ----------------------------------------------------------------
    // 3. PROJECTS — each section animates as it enters
    // ----------------------------------------------------------------
    document.querySelectorAll('.artist-project').forEach(function (section) {
        // Header
        gsap.from(section.querySelector('.artist-project__header'), {
            scrollTrigger: { trigger: section, ...ST_DEFAULTS },
            opacity: 0,
            y: 40,
            duration: 0.7,
            ease: 'power2.out',
        });

        // Main image — slight zoom out reveal
        const mainImg = section.querySelector('.artist-project__main-image');
        if (mainImg) {
            gsap.from(mainImg, {
                scrollTrigger: { trigger: mainImg, ...ST_DEFAULTS },
                opacity: 0,
                y: 60,
                scale: 0.97,
                duration: 0.9,
                ease: 'power3.out',
            });
        }

        // Gallery items — stagger
        const galleryItems = section.querySelectorAll('.artist-project__gallery-item');
        if (galleryItems.length) {
            gsap.from(galleryItems, {
                scrollTrigger: { trigger: section.querySelector('.artist-project__gallery'), ...ST_DEFAULTS },
                opacity: 0,
                y: 50,
                duration: 0.6,
                stagger: 0.1,
                ease: 'power2.out',
            });
        }

        // CTA button
        const cta = section.querySelector('.artist-project__cta');
        if (cta) {
            gsap.from(cta, {
                scrollTrigger: { trigger: cta, ...ST_DEFAULTS },
                opacity: 0,
                x: 20,
                duration: 0.5,
                ease: 'power2.out',
            });
        }
    });

    // ----------------------------------------------------------------
    // 4. SELECTED CLIENTS — fade up
    // ----------------------------------------------------------------
    const clientsSection = document.querySelector('.artist-clients');
    if (clientsSection) {
        gsap.from([
            clientsSection.querySelector('.artist-clients__heading'),
            clientsSection.querySelector('.artist-clients__list'),
        ], {
            scrollTrigger: { trigger: clientsSection, ...ST_DEFAULTS },
            opacity: 0,
            y: 40,
            duration: 0.8,
            stagger: 0.15,
            ease: 'power2.out',
        });
    }

    // ----------------------------------------------------------------
    // 5. HIRE CTA — pop-in with slight scale
    // ----------------------------------------------------------------
    const hireSection = document.querySelector('.artist-hire');
    if (hireSection) {
        gsap.from([
            hireSection.querySelector('.artist-hire__heading'),
            // hireSection.querySelector('.btn-primary'),
        ], {
            scrollTrigger: { trigger: hireSection, ...ST_DEFAULTS },
            opacity: 0,
            y: 30,
            scale: 0.95,
            duration: 0.7,
            stagger: 0.15,
            ease: 'back.out(1.4)',
        });
    }

    // ----------------------------------------------------------------
    // 6. RELATED WORK — cards fan in with rotation
    // ----------------------------------------------------------------
    const relatedCards = document.querySelectorAll('.artist-related__card');
    if (relatedCards.length) {
        relatedCards.forEach(function (card, i) {
            const targetRotation = i % 2 === 0 ? -4.54 : 6.65;
            gsap.fromTo(card,
                { opacity: 0, y: 60, rotate: 0 },
                {
                    scrollTrigger: {
                        trigger: '.artist-related',
                        ...ST_DEFAULTS,
                    },
                    opacity: 1,
                    y: 0,
                    rotate: targetRotation,
                    duration: 0.8,
                    delay: i * 0.1,
                    ease: 'power3.out',
                }
            );
        });
    }

    // ----------------------------------------------------------------
    // 7. VIDEO MODAL — basic lightbox trigger
    // Opens hero video in a simple overlay. Replace with your
    // preferred video modal library if already used globally.
    // ----------------------------------------------------------------
    const playBtn = document.querySelector('.js-video-trigger');
    if (playBtn) {
        playBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const videoUrl = this.dataset.video;
            if (!videoUrl) return;

            // Convert YouTube/Vimeo URL to embed format
            const embedUrl = getEmbedUrl(videoUrl);
            if (!embedUrl) {
                window.open(videoUrl, '_blank');
                return;
            }

            openVideoModal(embedUrl);
        });
    }

    function getEmbedUrl(url) {
        // YouTube
        const ytMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?/]+)/);
        if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&rel=0`;

        // Vimeo
        const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
        if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;

        return null;
    }

    function openVideoModal(embedUrl) {
        const modal = document.createElement('div');
        modal.className = 'fbd-video-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', 'Video player');
        modal.innerHTML = `
            <div class="fbd-video-modal__backdrop"></div>
            <div class="fbd-video-modal__inner">
                <button class="fbd-video-modal__close" aria-label="Close video">&times;</button>
                <div class="fbd-video-modal__frame">
                    <iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
            </div>`;

        document.body.appendChild(modal);
        document.body.style.overflow = 'hidden';

        // GSAP animate in
        gsap.from('.fbd-video-modal__inner', {
            opacity: 0,
            scale: 0.9,
            duration: 0.4,
            ease: 'power3.out',
        });

        function closeModal() {
            gsap.to('.fbd-video-modal__inner', {
                opacity: 0,
                scale: 0.9,
                duration: 0.3,
                ease: 'power3.in',
                onComplete: function () {
                    modal.remove();
                    document.body.style.overflow = '';
                },
            });
        }

        modal.querySelector('.fbd-video-modal__close').addEventListener('click', closeModal);
        modal.querySelector('.fbd-video-modal__backdrop').addEventListener('click', closeModal);
        document.addEventListener('keydown', function onKey(e) {
            if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', onKey); }
        });
    }
}

function aboutUsAnimations() {
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));

    // SET SECTION TITLES ANIMATION
    const titles = document.querySelectorAll(".a-title");
    titles.forEach(title => {
        const splitTxt = new SplitText(title, {type: "chars,words"});
        gsap.from(splitTxt.chars, {
            duration: 0.4,
            // scale: 2,
            x: "-=20",
            autoAlpha: 0,
            rotateY: 50,
            // rotateZ: -15,
            stagger: 0.05,
            scrollTrigger: {
                trigger: title,
                start: "top center+=20%",
                toggleActions: "play none none reverse",
            }
        });
    });

    //SET TEAM ANIMATION

    if(!isSmall) {
    
        const title = document.querySelector(".TeamHeading .pinned .a-title");
        const teambg = document.querySelector(".TeamHeading .team-bg");
        const teamMembers = document.querySelectorAll(".member-box");
        // let shouldRise = 1; // 1: rise up, -1: strech down
        const startScale = 0.25, endScale = 1.8, startY = "0%", endY = "-5%";
        // const titleScale = 0.8, titleOpacity = 0.6;
        const teamTl = gsap.timeline().invalidate();

        const scaleUpTeamBgTween = gsap.to(teambg, {
            scale: endScale,
            y: endY,
            ease: "power4.in",
            scrollTrigger: {
                trigger: '.TeamHeading',
                start: "top center-=225",
                end: "+=50%",
                scrub: true,
            }
        })
        const scaleUpTeamBgTweenReversed = gsap.to(teambg, {
            scale: startScale,
            y: startY,
            ease: "power4.out",
            scrollTrigger: {
                trigger: '.TeamMembers',
                start: "bottom bottom+=10%",
                // end: "+=200",
                endTrigger: ".TeamMembers",
                scrub: true,
                // markers: true
            }
        })
        teamTl.add([
            gsap.from(teambg, {
                autoAlpha: 0,
                duration: 0.5,
                scrollTrigger: {
                    trigger: ".TeamHeading",
                    start: "top bottom-=25%",
                    end: "+=50%",
                    scrub: 1,
                }
            }),
        ])
        .add(
            gsap.set(teambg, {scale: startScale, y: startY}).invalidate()
        )
        .add([
            gsap.to(".TeamHeading", {
                scrollTrigger: {
                    trigger: '.TeamHeading',
                    start: "top center-=225",// 165px padding of .Team + 60px half height of title
                    end: "bottom bottom-=200",
                    endTrigger: ".TeamMembers",
                    pin: true,
                    pinSpacing: false,
                    fastScrollEnd: true,
                    // markers: true,
                }
            }),
        ])
        .add(
            gsap.set(title, {filter: "blur(0px) grayscale(0)", scale: 1, opacity: 1}).invalidate()
        )
        .add([
            gsap.to(title, {
                duration: 0.5,
                opacity: 0.5,
                filter: "blur(3px) grayscale(0.9)",
                scale: 0.9,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: ".TeamMembers",
                    start: "top center+=5%",
                    end: "+=300",
                    scrub: true,
                    // markers: true,
                }
            })
        ])
        .add(scaleUpTeamBgTween)
        .add(scaleUpTeamBgTweenReversed.invalidate())
        .add(
            gsap.set(title, {filter: "blur(3px) grayscale(0.9)", scale: 0.9, opacity: 0.5})
        )
        .add(
            gsap.to(title, {
                duration: 0.5,
                opacity: 1,
                filter: "blur(0px) grayscale(0)",
                scale: 1,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: ".TeamMembers",
                    start: "bottom center+=25%",
                    end: "+=300",
                    scrub: true,
                    // markers: true,
                }
            })
        )
        .add(scaleUpTeamBgTweenReversed)
        .add(
            gsap.set(teambg, {scale: endScale, y: endY})
        )

        teamMembers.forEach(tm => {
            gsap.from(tm, {
                autoAlpha: 0,
                top: "-=35",
                duration: 0.8,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: tm,
                    start: "top bottom-=20%",
                    end: "top center-=25%",
                    toggleActions: "play none none reverse",
                    scrub: 1,
                }
            })
        })
        
    } else {
        const members = gsap.utils.toArray(".member-wrapper")
        ScrollTrigger.create({
            trigger: ".TeamHeading",
            start: "top center",
            endTrigger: `.member-wrapper:nth-child(${members.length - 1})`,
            toggleClass: {
                targets: ".AboutUsPage",
                className: "team-members",
            }
        })
    }

    // SET VALUES ANIMATION
    const values = document.querySelectorAll(".value-box");
    values.forEach(val => {
        gsap.from(val, {
            duration: 0.8,
            rotateX: 90,
            autoAlpha: 0,
            ease: "power4.out",
            scrollTrigger: {
                trigger: val,
                start: "top bottom-=10%",
                toggleActions: "play none none reverse",
                // scrub: 0.3,
                // markers: true,
            }
        });
    });
}

function blogAnimations() {
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));
}

function blogArticleAnimations() {
    let tl1 = gsap.timeline();
    tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));
}

// magnetic buttons
let magnets = document.querySelectorAll('.magnetic')
let strength = 50

magnets.forEach((magnet) => {
    magnet.addEventListener('mousemove', moveMagnet);
    magnet.addEventListener('mouseout', function (event) {
        gsap.to(event.currentTarget, { duration: 1, x: 0, y: 0, ease: "power4.out" })
    });
});

function moveMagnet(event) {
    const magnetButton = event.currentTarget
    const bounding = magnetButton.getBoundingClientRect()

    //console.log(magnetButton, bounding)

    gsap.to(magnetButton, {
        duration: 1,
        x: (((event.clientX - bounding.left) / magnetButton.offsetWidth) - 0.5) * strength,
        y: (((event.clientY - bounding.top) / magnetButton.offsetHeight) - 0.5) * strength,
        ease: "power4.out"
    })
}




// jelly blob cursor

// Function for Mouse Move Scale Change
function getScale(diffX, diffY) {
    const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    return Math.min(distance / 2035, 0.05);
}
  
// Function For Mouse Movement Angle in Degrees
function getAngle(diffX, diffY) {
    return (Math.atan2(diffY, diffX) * 180) / Math.PI;
}
  
// Jelly Blob Function
// Gsap Ticker Function
function useTicker(callback, paused) {
    if (!paused && callback) {
        gsap.ticker.add(callback);
    }
    return () => {
        gsap.ticker.remove(callback);
    };
}
const JellyBlob = () => {


    
    // React Refs for Jelly Blob and Text
    const jellyRef = document.querySelector("#jelly-id");
    const textRef = document.querySelector("#text-id");
  
    // Save pos and velocity Objects
    const pos = { x: 0, y: 0 };
    const vel = { x: 0, y: 0 };
    const set = {};
  
    // Set GSAP quick setter Values on useLayoutEffect Update
    set.x = gsap.quickSetter(jellyRef, "x", "px");
    set.y = gsap.quickSetter(jellyRef, "y", "px");
    set.r = gsap.quickSetter(jellyRef, "rotate", "deg");
    set.sx = gsap.quickSetter(jellyRef, "scaleX");
    set.sy = gsap.quickSetter(jellyRef, "scaleY");
    set.width = gsap.quickSetter(jellyRef, "width","px");
    set.rt = gsap.quickSetter(textRef, "rotate", "deg");
  
    // Start Animation loop
    const loop = () => {
        // Calculate angle and scale based on velocity
        var rotation = getAngle(vel.x, vel.y); // Mouse Move Angle
        var scale = getScale(vel.x, vel.y); // Blob Squeeze Amount
    
        // Set GSAP quick setter Values on Loop Function
        set.x(pos.x);
        set.y(pos.y);
        set.width(100+ (scale*150));
        set.r(rotation);
        set.sx(1 + scale);
        set.sy(1 - scale);
        set.rt(-rotation);
    };
  
    // Run on Mouse Move
    // Caluclate Everything Function
    const setFromEvent = (e) => {
        // Mouse X and Y
        const x = e.clientX;
        const y = e.clientY;

        // Animate Position and calculate Velocity with GSAP
        gsap.to(pos, {
            x: x,
            y: y,
            duration: 1.25,
            ease: "expo.easeOut",
            onUpdate: () => {
                vel.x = x - pos.x;
                vel.y = y - pos.y;
            }
        });

        loop();
    };
  
    useTicker(loop);

    window.addEventListener("mousemove", setFromEvent);
    return () => {
        window.removeEventListener("mousemove", setFromEvent);
    };
};


// function initTest() {
//     // commonInit();
//     const easing = "none";
//     let tl1 = gsap.timeline();
//     tl1.add(gsap.to(document.body, { autoAlpha: 1, duration: 0.5, delay: showPageDelay }));
//     gsap.to("#c1", { duration: 3, morphSVG:"#c2", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#d1", { duration: 3, morphSVG:"#d2", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#e1a", { duration: 3, morphSVG:"#e2a", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#e1b", { duration: 3, morphSVG:"#e2b", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#f1a", { duration: 3, morphSVG:"#f2a", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#f1b", { duration: 3, morphSVG:"#f2b", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#g1a", { duration: 3, morphSVG:"#g2a", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#g1b", { duration: 3, morphSVG:"#g2b", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#h1a", { duration: 3, morphSVG:"#h2a", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
//     gsap.to("#h1b", { duration: 3, morphSVG:"#h2b", repeat:100, yoyo:true, repeatDelay:0.0, ease: easing});
// }


if (document.body.classList.contains("ComingSoon")) {
    window.addEventListener("load", initCS);
} else if (document.body.classList.contains("HomePage")) {
    window.addEventListener("load", initHome);
    // JellyBlob()
} else if (document.body.classList.contains("ProjectsPage")) {
    window.addEventListener("load", initProjects);
} else if (document.body.classList.contains("SingleProjectPage")) {
    window.addEventListener("load", initSingleProject);
} else if (document.body.classList.contains("AboutUsPage")) {
    window.addEventListener("load", initAboutUs);
} else if (document.body.classList.contains("TalentsPage")) {
    window.addEventListener("load", initTalents);
} else if (document.body.classList.contains("SingleTalentPage")) {
    window.addEventListener("load", initSingleArtist);
} else if (document.body.classList.contains("Blog") || document.body.classList.contains("InsightsPage") || document.body.classList.contains("PodcastsPage")) {
    window.addEventListener("load", initBlog);
} else if (document.body.classList.contains("BlogPost") || document.body.classList.contains("SingleInsightPage") || document.body.classList.contains("SinglePodcastPage")) {
    window.addEventListener("load", initBlogArticle);
} else if (document.body.classList.contains("ErrorPage")) {
    window.addEventListener("load", initErrorPage);
// } else if (document.body.classList.contains("TestPage")) {
//     window.addEventListener("load", initTest);
}


/*const strength_li = 150
const strength_a = 300
// const section = document.querySelector(".test");
// const wrapper = document.querySelector(".test .container");
// const wbb = section.getBoundingClientRect();
const magnetsli = document.querySelectorAll('.magneticli a');
const mag = document.querySelector(".magnets");
const bb = mag.getBoundingClientRect();
// const mlen = magnetsli.length;
function moveMagnets(event) {
    magnetsli.forEach((mli, idx) => {
        if (event.target != mli) {
            const mmbb = mli.getBoundingClientRect()
            gsap.to(mli, {
                duration: 1,
                x: (((event.clientX - mmbb.left) / bb.width) - 0.1) * strength_li * -1,
                y: (((event.clientY - mmbb.top) / bb.height) - 0.1) * strength_li * -1,
                ease: "power4.out"
            })
        } else {
            const mmbb = mli.getBoundingClientRect()
            gsap.to(mli, {
                duration: 1,
                x: (((event.clientX - mmbb.left) / mli.offsetWidth) - 0.5) * strength_a,
                y: (((event.clientY - mmbb.top) / mli.offsetHeight) - 0.5) * strength_a,
                ease: "power4.out"
            })
        }
    });
}

mag.addEventListener("mousemove", moveMagnets);
mag.addEventListener("mouseout", function(event) {
    magnetsli.forEach(mm => {
        gsap.to(mm, { duration: 1, x: 0, y: 0, ease: "power4.out" })
    })
});*/

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

window.copyLink = function() {
    if (navigator.clipboard) {
        console.log('copy link');
        //
        const toastLiveExample = document.getElementById('liveToast');
        const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLiveExample);
        const link = document.location.href;
        // toastBootstrap.show();
        navigator.clipboard.writeText(link).then(() => {
            // alert('Link copied to clipboard!');
            toastBootstrap.show();
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }
    return false;
};